export const FORGOT_PIN = 'FORGOT_PIN';

export const RESET_FORGOTTEN_PIN_REQUEST = 'RESET_FORGOTTEN_PIN_REQUEST';
export const RESET_FORGOTTEN_PIN_SUCCESS = 'RESET_FORGOTTEN_PIN_SUCCESS';
export const RESET_FORGOTTEN_PIN_FAILURE = 'RESET_FORGOTTEN_PIN_FAILURE';

export const GET_CONVERSATION_DETAILS = 'GET_CONVERSATION_DETAILS';
export const GET_CONVERSATION_DETAILS_SUCCESS = 'GET_CONVERSATION_DETAILS_SUCCESS';
export const GET_CONVERSATION_DETAILS_FAILURE = 'GET_CONVERSATION_DETAILS_FAILURE';

export const VERIFY_DOB_REQUEST = 'VERIFY_DOB_REQUEST';
export const VERIFY_DOB_SUCCESS = 'VERIFY_DOB_SUCCESS';

export const VERIFY_NAME_REQUEST = 'VERIFY_NAME_REQUEST';
export const VERIFY_NAME_SUCCESS = 'VERIFY_NAME_SUCCESS';

export const SAVE_PIN_REQUEST = 'SAVE_PIN_REQUEST';
export const SAVE_PIN_SUCCESS = 'SAVE_PIN_SUCCESS';

export const LIMITED_LOGIN_REQUEST = 'LIMITED_LOGIN_REQUEST';
export const LIMITED_LOGIN_SUCCESS = 'LIMITED_LOGIN_REQUEST_SUCCESS';

export const LIMITED_LOGIN_SEND_MESSAGE_REQUEST = 'LIMITED_LOGIN_SEND_MESSAGE_REQUEST';
export const LIMITED_LOGIN_SEND_MESSAGE_SUCCESS = 'LIMITED_LOGIN_SEND_MESSAGE_SUCCESS';
export const LIMITED_LOGIN_SEND_MESSAGE_ERROR = 'LIMITED_LOGIN_SEND_MESSAGE_ERROR';

export const LIMITED_LOGIN_SEND_MESSAGE_TIMER = 'LIMITED_LOGIN_SEND_MESSAGE_TIMER';
export const LIMITED_LOGIN_SEND_MESSAGE_TIMER_END = 'LIMITED_LOGIN_SEND_MESSAGE_TIMER_END';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const GET_ATTACHMENT = 'GET_ATTACHMENT';
export const GET_ATTACHMENT_SUCCESS = 'GET_ATTACHMENT_SUCCESS';
export const GET_ATTACHMENT_ERROR = 'GET_ATTACHMENT_ERROR';

export const GET_MESSAGES = 'GET_MESSAGES';
export const GET_MESSAGES_SUCCESS = 'GET_MESSAGES_SUCCESS';

export const GET_ALL_CONVERSATIONS = 'GET_ALL_CONVERSATIONS';
export const GET_ALL_CONVERSATIONS_SUCCESS = 'GET_ALL_CONVERSATIONS_SUCCESS';

export const SWITCH_CONVERSATION = 'SWITCH_CONVERSATION';
export const SWITCH_CONVERSATION_SUCCESS = 'SWITCH_CONVERSATION_SUCCESS';

export const REPLY_TO_CONVERSATION = 'REPLY_TO_CONVERSATION';
export const REPLY_TO_CONVERSATION_SUCCESS = 'REPLY_TO_CONVERSATION_SUCCESS';
export const REPLY_ERROR = 'REPLY_ERROR';
export const CONVERSATION_ERROR = 'CONVERSATION_ERROR';

export const REQUEST_PENDING = 'REQUEST_PENDING';
export const REQUEST_COMPLETE = 'REQUEST_COMPLETE';

export const SESSION_TIME_REQUEST = 'SESSION_TIME_REQUEST';
export const SESSION_TIME_SUCCESS = 'SESSION_TIME_SUCCESS';